import { FormikErrors, FormikValues, getIn, setIn } from 'formik'

export const FIELD_CONFLICT_MESSAGE = "A field can't be both Private and Required."

const FIELDS_PATH = '_nested.fields_attributes'

interface FieldAttributes {
  private?: boolean
  required?: boolean
  _destroy?: boolean
}

const isFieldPrivateAndRequired = (field: FieldAttributes | null | undefined): boolean =>
  !!field && !field._destroy && !!field.private && !!field.required

export function hasFieldConflict(values: FormikValues): boolean {
  return (getIn(values, FIELDS_PATH) || []).some(isFieldPrivateAndRequired)
}

export function validateFields(values: FormikValues): FormikErrors<FormikValues> {
  return (getIn(values, FIELDS_PATH) || []).reduce(
    (errors: FormikErrors<FormikValues>, field: FieldAttributes, index: number) => {
      if (!isFieldPrivateAndRequired(field)) return errors

      const base = `${FIELDS_PATH}[${index}]`
      return setIn(setIn(errors, `${base}.private`, FIELD_CONFLICT_MESSAGE), `${base}.required`, FIELD_CONFLICT_MESSAGE)
    },
    {},
  )
}
